<!-- <mat-toolbar color="primary">
  <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon"
    (click)="drawer.toggle()"
  >
    <mat-icon>menu</mat-icon>
  </button>
  <span>Total Health and Fitness</span>
  <span class="example-spacer"></span>
  <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
    <mat-icon>favorite</mat-icon>
  </button>
  <button mat-icon-button class="example-icon" aria-label="Example icon-button with share icon">
    <mat-icon>share</mat-icon>
  </button>
</mat-toolbar> -->

<mat-drawer-container class="example-container">
  <mat-drawer
    #drawer
    mode="side"
    [opened]="isSideNavToggle$"
    class="side-menu-container"
    *ngIf="isLoggedIn$ | async as isLoggedIn"
    [ngStyle]="{ background: customBgColor }"
  >
    <div class="side-content">
      <div class="logo-container">
        <img [src]="logoUrl" alt="Company Logo" />
      </div>
      <div class="nav-divider"></div>
      <mat-nav-list class="side-list">
        <ng-container *ngFor="let item of sideNavData$ | async">
          <a
            mat-list-item
            *ngIf="item.show_in_menu == 1"
            (click)="redirect(item.name, item.id, item.display_name)"
            class="nav-list-item"
            [ngClass]="{ 'selected-side-nav': selectedItem === item.name }"
            [matTooltip]="item.display_name"
            matTooltipPosition="right"
          >
            <div class="nav-item-content">
              <mat-icon
                class="nav-icon"
                *ngIf="item.icon && item.icon.indexOf('.svg') === -1"
                >{{ item.icon }}</mat-icon
              >
              <img
                class="nav-icon-svg"
                *ngIf="item.icon && item.icon.indexOf('.svg') !== -1"
                [alt]="item.icon"
                [src]="'/assets/icons/' + item.icon"
              />
              <span class="nav-label" [class.nav-label-hidden]="!drawer.opened">
                {{ item.display_name }}
              </span>
            </div>
          </a>
        </ng-container>
      </mat-nav-list>
    </div>
    <!-- <div class="side-nav-footer">
      <p>Powered by</p>
      <p>Total Health and Fitness</p>
    </div> -->
  </mat-drawer>

  <mat-drawer-content>
    <div class="default-container">
      <app-header></app-header>
      <div class="main-container">
        <!-- <div class="main-loader">
    <mat-progress-bar mode="query" *ngIf="isDisplaySpinner$ | async as isDisplaySpinner"></mat-progress-bar>
  </div> -->
        <app-toaster-container></app-toaster-container>
        <router-outlet></router-outlet>
      </div>
      <!-- footer -->
      <app-footer></app-footer>
    </div>
  </mat-drawer-content>
</mat-drawer-container>